/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {LOCAL_STORAGE_SERVICE_CONFIG as ɵa} from './lib/local-storage.config.interface';